import { ComponentProps, useState } from "react";
import { CardStore } from "../CardStore";
import { ILojaDTO } from "../../../../../types/loja";
import { IEnderecoDTO } from "../../../../../types/endereco";

interface ICardStoreListProps extends ComponentProps<"div"> {
  onValueChange: (e: string) => void;
  stores: ILojaDTO[];
  name?: string;
}

export const CardStoreList = ({
  stores,
  name = "loja",
  onValueChange,
}: ICardStoreListProps) => {
  function addrFormat(data: IEnderecoDTO) {
    const addr = `${data.logradouro}, ${data.bairro} - ${data.cidade} / ${data.uf}`;
    return addr || "";
  }

  function serviceHoursFormat(data: ILojaDTO) {
    const serviceHours = `Seg à Sáb - ${data.horarioInicial}h às ${data.horarioFinal}h`;
    return serviceHours || "";
  }

  return (
    <div className="grid md:grid-cols-2 gap-2">
      {stores.map((i, k) => (
        <CardStore
          key={`${k}-${i.uuid}`}
          storeName={i.nome}
          address={addrFormat(i?.endereco)}
          serviceHours={serviceHoursFormat(i)}
          name={name}
          value={i.uuid || ""}
          onChange={(e) => onValueChange(e?.target?.value || "")}
        />
      ))}
    </div>
  );
};
